export default "__VITE_ASSET__z77kfQXo__"